exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-contenteditable[data-v-2b7ffd6e]{width:100%;word-break:break-word;cursor:text}.fts-contenteditable[data-v-2b7ffd6e]:empty:before{content:attr(placeholder);-webkit-text-fill-color:inherit;opacity:.45}.fts-contenteditable.content-nowrap[data-v-2b7ffd6e]{overflow:hidden;white-space:nowrap}.fts-contenteditable.content-wrap[data-v-2b7ffd6e]{word-break:break-word}.fts-contenteditable.disabled[data-v-2b7ffd6e]{cursor:default}", ""]);

// exports
